<template>
  <div class="col-md-12">
    <aside class="sidebar">
      <h4 class="heading-primary">Menu</h4>
      <ul class="nav nav-list mb-xl">
        <li>
          <router-link :to="{ path: '/' }">Dashboard</router-link>
        </li>
        <li v-show="!$store.state.verification.verificationSuccess">
          <router-link :to="{ path: '/register/form' }">Isi Formulir</router-link>
        </li>
        <li v-show="$store.state.verification.verificationSuccess">
          <router-link :to="{ path: '/register/kartu' }"
            >Kartu Ujian
          </router-link>
        </li>
        <!-- <li v-show="isS2S3">
          <a
            data-toggle="collapse"
            href="#managementcollapse"
            role="button"
            aria-expanded="false"
            aria-controls="collapseTwo"
            >Letter of Acceptance
          </a>
          <ul class="collapse" id="managementcollapse" role="tabpanel">
            <li v-show="!isMoment && isS2S3">
              <router-link :to="{ path: '/conditional-loa' }"
                >Conditional LoA
              </router-link>
            </li>
            <li v-show="isMoment && isS2S3">
              <router-link :to="{ path: '/regular-loa' }"
                >Regular LoA
              </router-link>
            </li>
          </ul>
        </li> -->
        <li>
          <a href="" @click="logout">Logout</a>
        </li>
      </ul>
      <h4 class="heading-primary hidden-xs"><i class="fa fa-bullhorn"></i> Pengumuman</h4>
      <ul class="nav nav-list mb-xlg sort-source hidden-xs">
        <li
          v-for="item in $store.state.pengumuman.randomThree.filter(el => el)"
          :key="item.id"
        >
          <a
            @click="() => goToDetailPengumuman(item.id_pengumuman)"
            style="cursor: pointer"
            >{{ item.judul }}</a
          >
        </li>
      </ul>
      <h4 class="heading-primary hidden-xs"><i class="fa fa-newspaper-o"></i> Artikel</h4>
      <ul class="nav nav-list mb-xlg sort-source hidden-xs">
        <li
          v-for="item in $store.state.artikel.randomThree.filter(el => el)"
          :key="item.id"
        >
          <a
            @click="() => goToDetailArtikel(item.id_berita)"
            style="cursor: pointer"
          >
            {{ item.judul }}</a
          >
        </li>
        <li>
          <a @click="() => goToCardArtikel()" style="cursor: pointer">
            <h6 class="heading-primary">
              Selengkapnya...
            </h6>
          </a>
        </li>
      </ul>
    </aside>
  </div>
</template>

<script>
export default {
  data() {
    return {
      role: null,
      isMoment: false,
      isS2S3: false,
      pengumuman: []
    }
  },
  mounted() {
    this.role = this.$store.getters.getAuthData.role
    this.isMoment = this.$store.getters.getAuthData.isPengumuman
    this.isS2S3 = this.$store.getters.getAuthData.isS2S3
    // For sidebar data
    // let pengumuman = this.$store.getters.allPengumuman
    // this.pengumuman = [
    //   pengumuman.length > 0 ? pengumuman[0] : null,
    //   pengumuman.length > 1 ? pengumuman[1] : null,
    //   pengumuman.length > 2 ? pengumuman[2] : null
    // ]
  },
  methods: {
    logout() {
      this.$store.dispatch('verificationReset')
      this.$store.dispatch('resetFormData')
      this.$store.dispatch('resetCatatanForm')
      this.$store.dispatch('resetStatus')
      this.$store.dispatch('logout')
      localStorage.removeItem('vuex-admisi-client')
    },
    goToDetailArtikel(id) {
      this.$store.dispatch('getOneArtikel', id)
      this.$router.push({ name: 'ArtikelDetail', params: { id_berita: id } })
    },
    goToDetailPengumuman(id) {
      this.$store.dispatch('getOnePengumuman', id)
      this.$router.push({
        name: 'PengumumanDetail',
        params: { id_pengumuman: id }
      })
    },
    goToCardArtikel() {
      this.$router.push({ name: 'ArtikelCardList' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sidebar.vue